module.exports = __webpack_public_path__ + "src/assets/img/screen02.6e29b80d.jpg";